import {
    SIGN_UP,
    LOGIN,
    SAVE_TOKEN,
    SET_USER_LOGGED,
    LOGOUT,
    SIGN_UP_WITH_FACEBOOK,
    FORGOT_PASSWORD,
    CONFIRM_EMAIL,
    RESEND_EMAIL,
    CHANGE_LOGGED_IN_STATUS,
    CHANGE_USER_EDITED_VALUE,
    REMOVE_USER_DETAILS,
    PUBLIC_PAGES
} from './action.type'
import $axios from '../../helpers/axios-instance';
import {
    SIGN_UP_MUTATION,
    LOGIN_MUTATION,
    SAVE_TOKEN_MUTATION,
    SET_USER_LOGGED_MUTATION,
    LOGOUT_MUTATION,
    SIGN_UP_WITH_FACEBOOK_MUTATION,
    CHANGE_LOGGED_IN_STATUS_MUTATION,
    CHANGE_USER_EDITED_VALUE_MUTATION,
    REMOVE_USER_DETAILS_MUTATION
} from './mutation.type';

export default {
    [SIGN_UP](context, userDetails) {
        return new Promise((resolve, reject) => {
            console.log(userDetails)
            $axios.post('/auth/register', {
                ...userDetails
            }).then(response => {
                console.log(response.data.data);
                context.commit(SIGN_UP_MUTATION, response.data.data);
                resolve(response)
            }).catch(error => {
                console.log(error);
                reject(error);
            })
        })
    },

    [SIGN_UP_WITH_FACEBOOK](context, token) {
        return new Promise((resolve, reject) => {
            $axios.post('/auth/loginWithFacebook', {
                facebookAccessToken: token
            }).then(response => {
                console.log(response)
                context.commit(SIGN_UP_WITH_FACEBOOK_MUTATION, response.data.data);
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },

    [LOGIN](context, loginDetails) {
        return new Promise((resolve, reject) => {
            $axios.post('/auth/login', {
                ...loginDetails
            }).then(response => {
                console.log(response.data.data)
                context.commit(LOGIN_MUTATION, response.data.data);
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },

    [SAVE_TOKEN](context, token) {
        return new Promise((resolve, reject) => {
            context.commit(SAVE_TOKEN_MUTATION, token);
            resolve(token)
        })
    },

    [SET_USER_LOGGED](context, value) {
        context.commit(SET_USER_LOGGED_MUTATION, value);
    },

    [LOGOUT](context) {
        context.commit(LOGOUT_MUTATION);
    },

    [FORGOT_PASSWORD](context, body) {
        return new Promise((resolve, reject) => {
            $axios.post('/auth/forgetPassword', {
                email: body.email
            }).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error)
            })
        })
    },

    [CONFIRM_EMAIL](context, userId) {
        return new Promise((resolve, reject) => {
            $axios.post('/auth/confirmEmail', {
                _id: userId
            }).then(response => {
                console.log("From action of confirm email " + response)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },

    [RESEND_EMAIL](context, email) {
        console.log(email)
        return new Promise((resolve, reject) => {
            $axios.post('/auth/resendVerificationEmail', {
                email: email
            }).then(response => {
                console.log(response)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },

    [CHANGE_LOGGED_IN_STATUS](context, payload) {
        context.commit(CHANGE_LOGGED_IN_STATUS_MUTATION, payload);
    },

    [CHANGE_USER_EDITED_VALUE](context, data) {
        console.log(data)
        context.commit(CHANGE_USER_EDITED_VALUE_MUTATION, data);
    },

    [REMOVE_USER_DETAILS](context) {
        context.commit(REMOVE_USER_DETAILS_MUTATION);
    },

    [PUBLIC_PAGES](context, slug) {
        return new Promise((resolve, reject) => {
            $axios.get('/page/' + slug).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    }
}